export default "__VITE_ASSET__BGCyzp9Q__"